module.exports = __webpack_public_path__ + "img/socialon_web.57abf24e.jpg";